export const FooterOne = () => {
  return (
    <>
      <section className="lets-talk sec-pad">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-9 col-lg-8 col-xl-7">
              <div className="title special">
                <span style={{
                  color: "black"
                }}>Let’s Talk</span>
                <h2 style={{
                  color: "black"
                }}>
                  About Your Next <br />
                  <b>Project</b> Your Mind
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4 col-lg-4 col-xl-4">
              <div className="footer-widget">
                <div className="footer-logo">
                  <a href="#">
                    <img src="assets/img/logo.png" alt="" />
                  </a>
                </div>
                <address>
                  <h4>Office</h4>
                  <p>House @ 137, St 48
	Sector F-11/3
	Islamabad.</p>
                </address>
              </div>
            </div>
            {/* <div className="col-md-3 col-lg-3 col-xl-3">
              <div className="footer-widget">
                <h4>Our Services</h4>
                <ul className="footer-menu">
                  <li>
                    <a href="#">Ensuring Provision of Quality Manpower.</a>
                  </li>
                  <li>
                    <a href="#">Employment of Ex-servicemen and Civilians.</a>
                  </li>
                  <li>
                    <a href="#">Web Solution</a>
                  </li>
                  <li>
                    <a href="#">Digital Merketing</a>
                  </li>
                  <li>
                    <a href="#">App Design</a>
                  </li>
                  <li>
                    <a href="#">App Development</a>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-md-4 col-lg-4 col-xl-4">
              <div className="footer-widget">
                <h4>Company</h4>
                <ul className="footer-menu">
                  <li>
                    <a href="#">About Us</a>
                  </li>
                  <li>
                    <a href="#">Services</a>
                  </li>
                  <li>
                    <a href="#">Trades</a>
                  </li>
                  <li>
                    <a href="#">Jobs</a>
                  </li>
                  <li>
                    <a href="#">Emmigration</a>
                  </li>
                  <li>
                    <a href="#">Contact Us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-4">
              <div className="footer-widget">
                <h4>Contacts</h4>
                <div className="number">
                  <div className="num-icon">
                    <i className="fas fa-phone-alt"></i>
                  </div>
                  <div className="phone">
                    <a href="#"> 
                    +92 300 8555710</a>
                    <a href="#"> +92 316 5897042</a>
                  </div>
                </div>
                <div className="office-mail">
                  <div className="mail-icon">
                    <i className="far fa-envelope"></i>
                  </div>
                  <div className="email">
                    
                    <a href="#">
                      <span
                        className="__cf_email__"
                        data-cfemail="86efe8e0e9c6f5f3f6f6e9f4f2a8e5e9eb"
                      >
                        info@capitalempagency.com

                      </span>
                    </a>
                  </div>
                </div>
                <div className="address">
                  <div className="address-icon">
                    <i className="fas fa-map-marker-alt"></i>
                  </div>
                  <p>House @ 137, St 48
	Sector F-11/3
	Islamabad.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="row align-items-center">
              <div className="col-12 col-md-4 col-lg-4 col-xl-5">
              </div>
              <div className="col-12 col-md-8 col-lg-8 col-xl-7">
                <ul className="footer-bottom-menu">
                  <li>
                    <a href="#">Privacy Policy</a>
                  </li>
                  <li>
                    <a href="#">Terms of Use</a>
                  </li>
                  <li>
                    <a href="#">Support Policy</a>
                  </li>
                  <li>
                    <a href="#">Terms of Service</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

